/** Каналы, которые можно отметить просмотренными. */
export type NotificationChannel = "comments" | "activity";

/** Плюс агрегат "all" — только на чтение, отметить просмотренным нельзя. */
export type ReadableChannel = NotificationChannel | "all";

export type ChannelSummary = {
  count: number;
  checkedAt: string | null;
};

export type NotificationsSummary = {
  channels: Partial<Record<ReadableChannel, ChannelSummary>>;
};

/** Ответ POST notifications/check/. */
export type CheckResponse = {
  channel: NotificationChannel;
  checkedAt: string;
  count: number;
};

/** Общий ключ запроса: им читаем сводку и её же инвалидируем после отметки. */
export const NOTIFICATIONS_QUERY_KEY = "notifications/";
